export default __webpack_public_path__ + "static/media/instructor-3.b4cb57cf.webp";